"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardCVC = exports.CardExpiry = exports.CardNumber = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _formUi = require("@foundation-lib/form-ui");

var _lodash = require("lodash");

var _useFormContext2 = _interopRequireDefault(require("./useFormContext"));

var _useField3 = _interopRequireDefault(require("./useField"));

var factory = function factory(name, Component) {
  return function (props) {
    var fieldName = (0, _lodash.camelCase)("stripe-".concat(name, "-complete"));

    var _useFormContext = (0, _useFormContext2["default"])(),
        isSubmitting = _useFormContext.isSubmitting,
        submitCount = _useFormContext.submitCount;

    var _useField = (0, _useField3["default"])(fieldName),
        _useField2 = (0, _slicedToArray2["default"])(_useField, 3),
        _useField2$ = _useField2[1],
        touched = _useField2$.touched,
        error = _useField2$.error,
        _useField2$2 = _useField2[2],
        setTouched = _useField2$2.setTouched,
        setValue = _useField2$2.setValue;

    return /*#__PURE__*/_react["default"].createElement(Component, (0, _extends2["default"])({}, props, {
      error: error && (touched || submitCount > 0),
      required: true,
      onBlur: function onBlur() {
        return setTouched(true, false);
      },
      onChange: function onChange(e) {
        return setValue(!e.empty && e.complete);
      },
      disabled: isSubmitting
    }));
  };
};

var CardNumber = factory('card-number', _formUi.StripeCardNumber);
exports.CardNumber = CardNumber;
var CardExpiry = factory('card-expiry', _formUi.StripeCardExpiry);
exports.CardExpiry = CardExpiry;
var CardCVC = factory('card-cvc', _formUi.StripeCardCVC);
exports.CardCVC = CardCVC;